import React from 'react';
import { Scroll, BookOpen, Lamp, Tag, FileText } from '@phosphor-icons/react';

export default function DohaModule({ metadata, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...metadata, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Doha Text */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Scroll size={16} weight="fill" className="text-amber-600" />
          Doha (दोहा) <span className="text-red-500">*</span>
        </label>
        <textarea
          value={metadata.doha_text || ''}
          onChange={(e) => handleChange('doha_text', e.target.value)}
          placeholder="दोहा लिखें (दो चरण, प्रत्येक में दो पंक्तियाँ)..."
          className="w-full px-6 py-4 bg-background border-2 border-border rounded-lg outline-none focus:border-primary transition-colors resize-none text-xl font-serif"
          rows={4}
          style={{ fontFamily: 'Noto Sans Devanagari, serif', lineHeight: '2' }}
          dir="auto"
        />
        <p className="text-xs text-muted-foreground mt-1">
          Traditional doha format: 13-11 syllable pattern
        </p>
      </div>

      {/* Live Preview */}
      {metadata.doha_text && (
        <div className="p-8 bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-950/20 dark:to-orange-950/20 rounded-xl border-2 border-amber-200 dark:border-amber-800">
          <div className="relative">
            <Scroll size={48} className="absolute -top-6 -left-2 text-amber-500/30" weight="fill" />
            <div className="text-2xl font-serif text-center relative z-10 whitespace-pre-wrap" style={{ fontFamily: 'Noto Sans Devanagari, serif', lineHeight: '2' }}>
              {metadata.doha_text}
            </div>
          </div>
        </div>
      )}

      {/* Meaning */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Lamp size={16} weight="fill" className="text-yellow-500" />
          Meaning (अर्थ)
        </label>
        <textarea
          value={metadata.meaning || ''}
          onChange={(e) => handleChange('meaning', e.target.value)}
          placeholder="सरल अर्थ हिंदी में लिखें..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Interpretation */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <BookOpen size={16} />
          Detailed Interpretation (विस्तृत व्याख्या)
        </label>
        <textarea
          value={metadata.interpretation || ''}
          onChange={(e) => handleChange('interpretation', e.target.value)}
          placeholder="दोहे की विस्तृत व्याख्या, भावार्थ, और महत्व..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={5}
        />
      </div>

      {/* Theme */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Tag size={16} />
          Theme (विषय)
        </label>
        <input
          type="text"
          value={metadata.theme || ''}
          onChange={(e) => handleChange('theme', e.target.value)}
          placeholder="e.g., नीति, सदाचार, ज्ञान, भक्ति"
          className="w-full px-4 py-2 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Source */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <FileText size={16} />
          Source (स्रोत)
        </label>
        <input
          type="text"
          value={metadata.source || ''}
          onChange={(e) => handleChange('source', e.target.value)}
          placeholder="e.g., कबीर के दोहे, रहीम के दोहे, विद्यापति"
          className="w-full px-4 py-2 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
        <p className="text-xs text-muted-foreground mt-1">
          Original text or poet name
        </p>
      </div>

      {/* Context */}
      <div>
        <label className="block text-sm font-medium mb-2">
          Historical/Cultural Context (संदर्भ)
        </label>
        <textarea
          value={metadata.context || ''}
          onChange={(e) => handleChange('context', e.target.value)}
          placeholder="ऐतिहासिक या सांस्कृतिक संदर्भ..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Info Banner */}
      <div className="bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
        <div className="flex gap-3">
          <BookOpen size={20} className="text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="font-medium text-blue-900 dark:text-blue-100 mb-1">
              About Doha (दोहे के बारे में)
            </p>
            <p className="text-blue-700 dark:text-blue-300">
              A doha is a classical two-line couplet with a 13-11 syllable pattern per line. Famous poets include Kabir, Rahim, Tulsidas, and Bihari.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
